var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.getparentproperty) +
          _vm._s(_vm.getConfirmBoxResponse) +
          "\n  "
      ),
      _c("div", [
        _vm._v("\n    " + _vm._s(_vm.test) + "\n     "),
        _c("li", { staticClass: "card parent searchtemplatehld" }, [
          _vm._m(0),
          _c("span", { staticClass: "form-tooltip" }, [
            _vm._v("Personal details"),
          ]),
          _c(
            "div",
            {
              staticClass: "ul-hold collapse wrapper",
              attrs: { id: "searchtemplet", "data-parent": "#accordion" },
            },
            [
              _c(
                "div",
                { staticClass: "panel-body panel-body-bg p-relative" },
                [
                  _vm.istempprocessing
                    ? _c("div", { attrs: { id: "cover-spin" } })
                    : _vm._e(),
                  !_vm.istempprocessing
                    ? _c("div", { staticClass: "searchboxhold" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.searchterm,
                              expression: "searchterm",
                            },
                          ],
                          staticClass: "seach-ico form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Search template",
                          },
                          domProps: { value: _vm.searchterm },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.searchterm = $event.target.value
                              },
                              _vm.searchTemplate,
                            ],
                          },
                        }),
                        _c("button", { staticClass: "s-icon" }),
                      ])
                    : _vm._e(),
                  _vm.clinicalTemplatesDispArr &&
                  _vm.clinicalTemplatesDispArr.length
                    ? _c(
                        "div",
                        { staticClass: "max-height-225 tempH-history-hold" },
                        _vm._l(_vm.clinicalTemplatesDispArr, function (item) {
                          return _c("div", { key: item.unique_id }, [
                            _c("div", { staticClass: "pt-history-left" }, [
                              _c("p", { staticClass: "template-head" }),
                              _c("div", {
                                domProps: { innerHTML: _vm._s(item.name) },
                              }),
                              _c("p"),
                            ]),
                            _c("div", { staticClass: "pt-history-right" }, [
                              _c("ul", [
                                _c("li", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "action-copy custom-ico",
                                      attrs: {
                                        type: "button",
                                        href: "javascript:void(0);",
                                        "data-toggle": "tooltip",
                                        title: "Copy",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.copyAll(
                                            _vm.trimHtml(item.template_text)
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Copy")]
                                  ),
                                ]),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "custom-ico1",
                                      staticStyle: {
                                        padding: "2px",
                                        "margin-left": "2px",
                                      },
                                      attrs: {
                                        href: "javascript:void(0);",
                                        "data-toggle": "tooltip",
                                        title: "Delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.confirmDelTemplate(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: {
                                            "font-size": "19px",
                                            color: "whitesmoke",
                                          },
                                        },
                                        [_vm._v("delete")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "li",
                                  {
                                    attrs: {
                                      "data-toggle": "tooltip",
                                      title: "View",
                                    },
                                  },
                                  [
                                    _c("a", {
                                      staticClass: "action-view",
                                      attrs: {
                                        href: "javascript:void(0);",
                                        "data-toggle": "popover",
                                        title: item.name,
                                        "data-placement": "right",
                                      },
                                    }),
                                    _c("div", {
                                      staticClass: "popper-content hide",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.trimHtml(item.template_text)
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]),
                          ])
                        }),
                        0
                      )
                    : _c(
                        "div",
                        { staticClass: "max-height-225 tempH-history-hold" },
                        [_vm._m(1)]
                      ),
                  _c("div", { staticClass: "btnhold" }, [
                    !(
                      _vm.clinicalTemplates &&
                      _vm.clinicalTemplatesDispArr &&
                      _vm.clinicalTemplates.length ==
                        _vm.clinicalTemplatesDispArr.length &&
                      _vm.noOfClickOnViewMore == 1
                    )
                      ? _c("span", [
                          !_vm.showViewLess
                            ? _c(
                                "a",
                                {
                                  staticClass: "view-more",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.viewMoreTemplate()
                                    },
                                  },
                                },
                                [_vm._v("View more")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "view-more",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.viewMoreTemplate()
                                    },
                                  },
                                },
                                [_vm._v("View less")]
                              ),
                        ])
                      : _vm._e(),
                    _c(
                      "a",
                      {
                        staticClass: "add-more",
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.openCreateTemplatePopup()
                          },
                        },
                      },
                      [_vm._v("Add new +")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        !_vm.IsVS
          ? _c("li", { staticClass: "card group1" }, [
              _c(
                "a",
                {
                  staticClass: "menu-title hover-effect white",
                  class: { active: _vm.selectedprescriptionmenu },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showbillingdetails()
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "billing toggle-menu toggle-menu-2 tooltip-text",
                    attrs: {
                      title: "Billing",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                    },
                  }),
                  _vm._v("Billing\n      "),
                ]
              ),
            ])
          : _vm._e(),
        _vm.showinvestigation
          ? _c("li", { staticClass: "card parent group1" }, [
              _c(
                "a",
                {
                  staticClass: "menu-title hover-effect white",
                  class: { active: _vm.selectedinvestigationmenu },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      return _vm.viewInvesti(true)
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "investigation toggle-menu toggle-menu-2 tooltip-text",
                    attrs: {
                      title: "Investigation",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                    },
                  }),
                  _vm._v("Investigation\n      "),
                ]
              ),
            ])
          : _vm._e(),
        !_vm.IsVS
          ? _c("li", { staticClass: "card group1" }, [
              _c(
                "a",
                {
                  staticClass: "menu-title hover-effect white",
                  class: { active: _vm.selectedproblems },
                  attrs: {
                    href: "#",
                    "data-toggle": "modal",
                    "data-target": "#Addproblemsill",
                    "data-backdrop": "static",
                    "data-keyboard": "false",
                  },
                  on: { click: _vm.addillness },
                },
                [
                  _c("span", {
                    staticClass:
                      "probillnss-leftICO toggle-menu toggle-menu-1 tooltip-text",
                    attrs: {
                      title: "ICD10",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                    },
                  }),
                  _vm._v("ICD10\n      "),
                ]
              ),
            ])
          : _vm._e(),
        _vm.IsVS
          ? _c("li", { staticClass: "card group1" }, [_vm._m(2)])
          : _c("li", { staticClass: "card group1" }, [
              _c(
                "a",
                {
                  staticClass: "menu-title hover-effect white",
                  class: { active: _vm.selectedprescriptionmenu },
                  attrs: {
                    href: "#",
                    "data-toggle": "modal",
                    "data-target": "#myModal1",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.openpriscriptionpopup(true)
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "prescription toggle-menu toggle-menu-2 tooltip-text",
                    attrs: {
                      title: "Prescription",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                    },
                  }),
                  _vm._v("Prescription\n      "),
                ]
              ),
            ]),
        _vm.showimmunization
          ? _c("li", { staticClass: "card" }, [
              _c(
                "a",
                {
                  staticClass: "menu-title hover-effect white",
                  class: { active: _vm.selectedimmunizationnmenu },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      return _vm.CreateImmunization(true)
                    },
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "immunization toggle-menu toggle-menu-2 tooltip-text ",
                    attrs: {
                      title: "Immunization",
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                    },
                  }),
                  _vm._v("\n        Immunization\n      "),
                ]
              ),
            ])
          : _vm._e(),
      ]),
      _c("createTemplatePopup", {
        attrs: {
          popuptitle: _vm.templatepopuptitle,
          showmodal: _vm.openshowtemplate,
        },
        on: {
          cancelAction: function ($event) {
            _vm.openshowtemplate = false
            _vm.templatepopuptitle = ""
          },
        },
      }),
      _c("ConfirmBox", {
        ref: "confirmcomp",
        attrs: { showmodal: _vm.showCnfrmPopUp, actionmessage: _vm.actionMsg },
        on: {
          cancelAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = false
          },
          confirmAction: function ($event) {
            _vm.showCnfrmPopUp = false
            _vm.confrmPopUpResponse = true
          },
        },
      }),
      _c("Messages", {
        attrs: {
          iserror: _vm.iserrormsg,
          datamessage: _vm.sucessmsgtext,
          isVisible: _vm.isdisplaymsg,
        },
        on: { closemsg: _vm.closeMessage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h5",
      {
        staticClass:
          "menu-title arrow-wd tooltip-cust hover-effect white collapsed tooltipcus",
        attrs: {
          id: "#searchtemplet",
          "data-toggle": "collapse",
          href: "#searchtemplet",
        },
      },
      [
        _c("span", {
          staticClass: "template toggle-menu toggle-menu-2 tooltip-text1",
          attrs: {
            title: "Templates",
            "data-toggle": "tooltip",
            "data-placement": "bottom",
          },
        }),
        _vm._v("\n        Templates "),
        _c("div", { staticClass: "tooltip-cus" }, [
          _c("span", { staticClass: "info-text" }, [
            _c("span", { staticClass: "header" }, [_vm._v("How it works !")]),
            _c("span", [
              _vm._v(
                "You can copy the content in the selected template and edit it as required. This will help you spend more time talking to the patient and less on documentation."
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("p", { staticClass: "template-head" }, [
        _c("span", [_vm._v("No template has been added")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "menu-title hover-effect white" }, [
      _c("span", {
        staticClass: "prescription toggle-menu toggle-menu-2 tooltip-text",
        attrs: {
          title: "Prescription",
          "data-toggle": "tooltip",
          "data-placement": "bottom",
        },
      }),
      _vm._v("Prescription\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }